import { Stack } from '@mui/material';

import { FormTextField } from '@/components/form/formTextField';

import type { IntegrationWizardState } from '../integrationWizardFlow';

interface MicrosoftFabricConfigurationProps {
  wizardState: IntegrationWizardState;
  setWizardState: (
    updater: (state: IntegrationWizardState) => IntegrationWizardState
  ) => void;
}

export const MicrosoftFabricConfiguration = ({
  wizardState,
  setWizardState,
}: MicrosoftFabricConfigurationProps) => {
  return (
    <Stack className='w-[582px]' gap='24px'>
      <FormTextField
        title='Tenant ID'
        placeholder='Example: 5f69ce7b-0782-4fbc-b546-360babd1e94c'
        value={wizardState.config?.fabric?.tenantId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              fabric: {
                tenantId: event.target.value,
                appId: state.config?.fabric?.appId || '',
                subscriptionId: state.config?.fabric?.subscriptionId || '',
                connectionId: state.config?.fabric?.connectionId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='Subscription ID'
        placeholder='Example: 19a4d441-7ed7-43b4-8900-492a55c6d634'
        value={wizardState.config?.fabric?.subscriptionId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              fabric: {
                tenantId: state.config?.fabric?.tenantId || '',
                appId: state.config?.fabric?.appId || '',
                subscriptionId: event.target.value,
                connectionId: state.config?.fabric?.connectionId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='App ID'
        placeholder='Example: bd892727-3440-4645-9a62-a6a0a12dbdc2'
        value={wizardState.config?.fabric?.appId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              fabric: {
                tenantId: state.config?.fabric?.tenantId || '',
                appId: event.target.value,
                subscriptionId: state.config?.fabric?.subscriptionId || '',
                connectionId: state.config?.fabric?.connectionId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='Connection ID'
        placeholder='Example: 7df5fa41-91f4-45dc-a717-c80914300ed2'
        value={wizardState.config?.fabric?.connectionId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              fabric: {
                tenantId: state.config?.fabric?.tenantId || '',
                appId: state.config?.fabric?.appId || '',
                subscriptionId: state.config?.fabric?.subscriptionId || '',
                connectionId: event.target.value,
              },
            },
          }))
        }
      />
    </Stack>
  );
};
